// sections/SectionUSI.jsx
import React from 'react';
import { Shield } from 'lucide-react';
import { Row, Col, Input, Select, SectionTitle, FormField, FileInput } from '../../../SharedInputs.jsx';

export function SectionUSI({ value, onChange, errors = [], dispatch }) {
  const updateField = (field, fieldValue) => {
    onChange({ ...value, [field]: fieldValue });
  };

  const updateUSIExemptionLetter = (file) => {
    dispatch({
      type: 'SET_FILE',
      section: 'usi',
      field: 'usiExemptionLetter',
      file
    });
  };

  return (
    <div>
      <SectionTitle icon={Shield} step={12}>Unique Student Identifier (USI)</SectionTitle>
      
      <div style={{
        padding: 16,
        background: '#fffbeb',
        borderRadius: 8,
        border: '1px solid #fed7aa',
        marginBottom: 24
      }}>
        <p style={{ margin: 0, fontSize: 14, color: '#92400e' }}>
          A USI is required for all students undertaking nationally recognized training in Australia. 
          You can create your USI at <strong>usi.gov.au</strong> or we can help you during enrollment.
          <br/><br/>
          Canberra Institute of Education and Technology can be prevented from issuing you with a nationally 
          recognised VET qualification or statement of attainment when you complete your course if you do not have a 
          Unique Student Identifier (USI). In addition, we are required to include your USI in the data we submit to 
          NCVER.  
        </p>
      </div>

      <Row>
        <Col>
          <FormField
            label="USI (if available)"
            hint={
              <>
                If you have not yet obtained a USI you can apply for it directly at{' '}
                <a
                  href="https://www.usi.gov.au/students/create-your-usi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2563eb', textDecoration: 'underline' }}
                >
                  https://www.usi.gov.au/students/create-your-usi/
                </a>{' '}
                on computer or mobile device.
              </>
            }
          >
            <Input
              value={value.usi}
              onChange={(e) => updateField('usi', e.target.value)}
              placeholder="10-digit USI number"
              maxLength={10}
            />
          </FormField>

        </Col>
      </Row>
      <Row>
        <Col>
          <FormField
            label="USI exemption provided?"
            hint={
              <>
                If you are exempt from having a Unique Student Identifier (USI), please email your USI exemption letter to us, along with your application for enrolment. Further details about USI exemptions can be found{' '}
                <a
                  href="https://www.usi.gov.au/exemptions"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2563eb', textDecoration: 'underline' }}
                >
                  https://www.usi.gov.au/exemptions
                </a>.
              </>
            }
          >
            <Select
              value={value.usiExemptionProvided}
              onChange={(e) => updateField('usiExemptionProvided', e.target.value)}
            >
              <option value="No">No</option>
              <option value="Yes">Yes</option>
            </Select>
          </FormField>

        </Col>
      </Row>

      {value.usiExemptionProvided === "Yes" && (
      <Row>
        <Col span={12}>
          <FormField
            label="Upload USI exemption letter"
            required
            error={errors.find(err => err.toLowerCase().includes('usi exemption letter'))}
          >
            <FileInput
              onChange={updateUSIExemptionLetter}
              value={value.usiExemptionLetter}
              placeholder="Upload exemption documentation"
              required
              error={errors.find(err => err.toLowerCase().includes('usi exemption letter'))}
            />
          </FormField>
        </Col>
      </Row>
    )}

    </div>
  );
}